module.exports = __webpack_public_path__ + "static/media/dappsinfo.aa8c9752.webp";